import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type SetInWatchlistMutationVariables = Types.Exact<{
	input: Types.SetInTitleListInput;
	country: Types.Scalars['Country'];
}>;

export type SetInWatchlistMutation = { __typename?: 'Mutation' } & {
	setInWatchlist: { __typename?: 'SetInTitleListPayload' } & {
		title:
			| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'id'> & {
						watchlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
					})
			| ({ __typename?: 'Show' } & Pick<Types.Show, 'id'> & {
						seenState: { __typename?: 'ShowSeenState' } & Pick<Types.ShowSeenState, 'seenEpisodeCount'>;
						seasons: Array<
							{ __typename?: 'Season' } & Pick<Types.Season, 'id'> & {
									show: { __typename?: 'Show' } & Pick<Types.Show, 'id'> & {
											watchlistEntry?: Types.Maybe<
												{ __typename?: 'TitleListEntry' } & Pick<
													Types.TitleListEntry,
													'createdAt'
												>
											>;
										};
								}
						>;
						watchlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
					});
	};
};

export const SetInWatchlistDocument = gql`
	mutation SetInWatchlist($input: SetInTitleListInput!, $country: Country!) {
		setInWatchlist(input: $input) {
			title {
				id
				watchlistEntry {
					createdAt
				}
				... on Show {
					seenState(country: $country) {
						seenEpisodeCount
					}
					seasons {
						id
						show {
							id
							watchlistEntry {
								createdAt
							}
						}
					}
				}
			}
		}
	}
`;
